import React from "react";
import { Outlet } from "react-router-dom";
import Swal from "sweetalert2";

import { useGetCustomer } from "../../api/customers";
import useInitialState from "../../hooks/useInitialState";
import useAuthStore from "../../stores/authStore";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import UnauthorizedRedirect from "../UnauthorizedRedirect";

export default function PrivateRoute() {
  const { loading } = useInitialState();
  const isLoggedIn = useAuthStore((s) => s.isLoggedIn);
  const { data: customer } = useGetCustomer();

  if (loading) {
    return (
      <div style={{ marginTop: "20vh" }} className="d-flex  justify-content-center">
        <LoadingSpinner />
      </div>
    );
  }

  if (isLoggedIn) {
    if (customer && customer.detail) {
      Swal.fire({ title: "Profile not found!", text: "Please complete your profile before accessing USMCA.", icon: "error" }).then(() => {
        window.location = `${import.meta.env.VITE_MAIN_SITE_URL}`;
      });
      return <LoadingSpinner />;
    }
    return <Outlet />;
  }

  return <UnauthorizedRedirect />;
}
